const Burgers = [
    {
        "id": 0,
        "name": "Tribute Burger",
        "restaurant": "Honest Burgers",
        "web": "www.honestburgers.co.uk",
        "description": "A mouth-watering honest beef burger",
        "ingredients": [
            "beef",
            "american cheese",
            "burger sauce",
            "french mustard",
            "pickes",
            "onion",
            "lettuce"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "75",
                "line1": "Venn Street",
                "line2": "Clapham",
                "postcode": "SW4 0BD",
                "country": "United Kingdom"
            }
        ],
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"

    },
    {
        "id": 1,
        "name": "Pulled Mooshie",
        "restaurant": "Mooshies",
        "web": "www.veganburger.org",
        "description": "Spicy vegan burger with jackfruit",
        "ingredients": [
            "jackfruit",
            "coleslaw",
            "gluten free bun"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "104",
                "line1": "Brick Lane",
                "line2": "Shoreditch",
                "postcode": "E1 6RL",
                "country": "United Kingdom"
            }
        ]
        ,
        "image": "https://th.bing.com/th/id/R.f0c42b344c391d9d4ba3eb06d925c07d?rik=b7Getp9CNyHqng&riu=http%3a%2f%2fwww.pngall.com%2fwp-content%2fuploads%2f5%2fHamburger-PNG-File.png&ehk=4zOajPzQNJsWJdEgCPsT6H6ps1LjJf0QS8vthW%2bKcLA%3d&risl=&pid=ImgRaw&r=0"
    },
    {
        "id": 2,
        "name": "Krabby Patty",
        "restaurant": "Krusty Krab",
        "web": "https://twitter.com/SpongeBob",
        "description": "The only people who don't like a Krabby Patty have never tasted one.",
        "ingredients": [
            "bun",
            "patty",
            "ketchup",
            "mustard",
            "pickles",
            "onions",
            "lettuce",
            "cheese",
            "tomato",
            "bun"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "831",
                "line1": "Bottom Feeder Lane",
                "line2": "",
                "postcode": "",
                "country": "Bikini Bottom, Pacific Ocean"
            }
        ]
        ,
        "image": "https://static.vecteezy.com/system/resources/previews/021/952/459/original/free-tasty-hamburger-on-transparent-background-free-png.png"
    },
    {
        "id": 3,
        "name": "The Good Burger",
        "restaurant": "Good Burger",
        "web": "https://en.wikipedia.org/wiki/Good_Burger",
        "description": "Welcome to Good Burger, home of the Good Burger, can I take your order?",
        "ingredients": [
            "bun",
            "tomato",
            "Ed's secret sauce",
            "lettuce",
            "onions",
            "cheese"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "000",
                "line1": "Good Burger",
                "line2": "437 Glendora Ave.",
                "postcode": "CA",
                "country": "United States"
            }
        ]
        ,
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
    {
        "id": 4,
        "name": "Crunchy Nacho Burger",
        "restaurant": "Max Burgers",
        "web": "https://www.max.se/maten/meny/burgare/crunchy-nacho-burger/",
        "description": "The best combination of crunchiness and softness, all in one single burger",
        "ingredients": [
            "sesame bun",
            "salsa",
            "cheddar",
            "nachos",
            "beef",
            "tomato",
            "pickled onion",
            "lettuce",
            "jalapeño mayonnaise"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "48D",
                "line1": "Skeppsbrogatan",
                "line2": "Luleå",
                "postcode": "971 25",
                "country": "Sweden"
            }
        ]
        ,
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
    {
        "id": 5,
        "name": "Barbie Burger",
        "restaurant": "Flower Burger",
        "web": "https://www.flowerburger.it/",
        "description": "From a pink explosion was born Barbie Burger, a special edition in partnership with Mattel",
        "ingredients": [
            "pink bun",
            "lentil and beetroot burger",
            "tomatoes",
            "gentilina salad",
            "barbie hummus",
            "barbie mayo"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "12",
                "line1": "Porta Genova",
                "line2": "Via Tortona",
                "postcode": "20144",
                "country": "Italy"
            }
        ],
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
    {
        "id": 6,
        "name": "Curry On My Wayward Bun",
        "restaurant": "Bob's Burgers",
        "web": "https://bobs-burgers.fandom.com/wiki/Burger_of_the_Day",
        "description": "Fast food joint located in a public toilet? Why on earth?!",
        "ingredients": [
            "beef",
            "curry",
            "bun"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "0",
                "line1": "Ocean Avenue",
                "line2": "NJ",
                "postcode": "08260",
                "country": "United States"
            }
        ]
        ,
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
    {
        "id": 7,
        "name": "MEISTER ALLER KLASSEN",
        "restaurant": "Burgermeister",
        "web": "https://burger-meister.de",
        "description": "Fast food joint located in a public toilet? Why on earth?!",
        "ingredients": [
            "2 x meat",
            "2 x cheese",
            "bacon",
            "barbequesauce",
            "jalapenos"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "1",
                "line1": "Potsdamer Platz",
                "line2": "Berlin",
                "postcode": "10785",
                "country": "Germany"
            },
            {
                "addressId": 1,
                "number": "45",
                "line1": "Eberswalder, Schönhauser Allee",
                "line2": "Berlin",
                "postcode": "10435",
                "country": "Germany"
            }
        ],
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
    {
        "id": 8,
        "name": "Vegetarian Burger (Indian Style)",
        "restaurant": "Indian Burgers",
        "web": "https://www.cookwithmanali.com/vegetarian-burger-indian-style/",
        "description": "With summer around the corner, I had to share a vegetarian burger recipe with you guys.",
        "ingredients": [
            "american cheese",
            "burger sauce",
            "french mustard",
            "pickes",
            "onion",
            "Veggies"
        ],
        "addresses": [
            {
                "addressId": 0,
                "number": "007",
                "line1": "Line1",
                "line2": "Line2",
                "postcode": "",
                "country": "India"
            }
        ],
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
    {
        "id": 9,
        "name": "Vegetarian Burger (Indian Style)",
        "description": "With summer around the corner, I had to share a vegetarian burger recipe with you guys.",
        "image": "https://pngimg.com/uploads/burger_sandwich/burger_sandwich_PNG96712.png"
    },
   
]

export {Burgers}